<div class="upload-media-modal">
  <div *ngIf="isUploading" class="loading-preload">
    <div class="spinner-border text-success"></div>
  </div>
  <div class="modal-header p-3 border-bottom">
    <h2 class="mb-0">{{ labelText | translate }}</h2>
    <button
      type="button"
      class="close text-primary"
      aria-label="Close"
      (click)="closeModal()"
    >
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body px-0 m-1 pb-0">
    <div class="section main">
      <div class="container col mb-4 mx-0">
        <mat-tab-group
          animationDuration="0ms"
          [disableRipple]="true"
          dynamicHeight
          (selectedTabChange)="switchMediaTab($event)"
        >
          <mat-tab label="{{ 'Upload Image' | translate }}">
            <div
              class="custom-dropzone"
              ngx-dropzone
              [accept]="UPLOAD_ACCEPT"
              (change)="onSelect($event)"
            >
              <ngx-dropzone-label>
                <div>
                  <h2>{{ "Select your file or Drop it" | translate }}</h2>
                </div>
              </ngx-dropzone-label>
              <ngx-dropzone-image-preview
                ngProjectAs="ngx-dropzone-preview"
                *ngFor="let f of files"
                [file]="f"
                [removable]="true"
                (removed)="onRemove(f)"
              >
              </ngx-dropzone-image-preview>
            </div>
            <div class="col-12" *ngIf="imgTooHeavy">
              <span style="color: #eb5757; margin-left: 20px">{{
                imgTooHeavyMsg
              }}</span>
            </div>
          </mat-tab>
          <mat-tab label="{{ 'Choose from gallery' | translate }}">
            <div class="mx-2">
              <div
                class="mb-3 preview-section flex justify-center"
                *ngIf="media_photo"
              >
                <img
                  *ngIf="imgURL"
                  [src]="imgURL"
                  class="image-uploaded checkered-bg"
                />
              </div>
              <div class="row mt-3 gallery-section px-2">
                <ng-container *ngIf="medias.length && medias">
                  <ng-container *ngFor="let media of medias">
                    <div
                      class="image-thumbnail-container"
                      [class]="{ selected: media_photo === media.media_id }"
                      [class.d-none]="onerror[media.media_id] === true"
                    >
                      <div
                        (click)="imageSelect(media.photo, media.media_id)"
                        class="mb-2 gallery-image-item"
                        [ngClass]="{
                          cursorDisabled: onerror[media.media_id] === true,
                          cursorPointer: onerror[media.media_id] !== true
                        }"
                      >
                        <img
                          class="image-thumbnail checkered-bg"
                          [src]="media.photo"
                          (error)="setErrorImg($event, media.media_id)"
                        />
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="mt-2">
      <div
        mat-button
        class="btn btn-red"
        (click)="closeModal()"
      >
        {{ "Cancel" | translate }}
      </div>
      <div
        mat-button
        class="btn btn-primary ml-2"
        (click)="uploadImage()"
        (click)="SaveIMG()"
      >
        {{
          "{0}"
            | translate : [utils.translate(mediaTab === 1 ? "Save" : "Select")]
        }}
      </div>
    </div>
  </div>
</div>
